<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_xii"></a><a id="page_xiii"></a><a id="pla"></a><strong>PLATES</strong></p>
<p class="toc-a"><a href="#/html/9780226160702_13_ch2#pla1">1. John Jones</a></p>
<p class="toc-a"><a href="#/html/9780226160702_13_ch2#pla2">2. Robert S. Abbott</a></p>
<p class="toc-a"><a href="#/html/9780226160702_13_ch2#pla3">3 and 4. Ferdinand and Ida Barnett</a></p>
<p class="toc-a"><a href="#/html/9780226160702_13_ch2#pla5">5. Olivet Baptist Church</a></p>
<p class="toc-a"><a href="#/html/9780226160702_13_ch2#pla6">6. Robert Mott’s Pekin Theater Cafe</a></p>
<p class="toc-a"><a href="#/html/9780226160702_13_ch2#pla7">7. Negro Women Strikebreakers</a></p>
<p class="toc-a"><a href="#/html/9780226160702_13_ch2#pla8">8. Negro Strikebreakers at Swift &amp; Company</a></p>
<p class="toc-a"><a href="#/html/9780226160702_13_ch2#pla9">9. Tenements on Federal Street</a></p>
<p class="toc-a"><a href="#/html/9780226160702_13_ch2#pla10">10. Middle-Class Negro Homes</a></p>
<p class="toc-a"><a href="#/html/9780226160702_13_ch2#pla11">11. Newly Arrived Negro Migrants</a></p>
<p class="toc-a"><a href="#/html/9780226160702_13_ch2#pla12">12. Alderman Oscar De Priest Posting Bond</a></p>
<p class="toc-a"><a href="#/html/9780226160702_13_ch2#pla13">13, 14, and 15. Mob Killing during the 1919 Riots</a></p>
<p class="toc-a"><a href="#/html/9780226160702_13_ch2#pla16">16. Policeman Escorting a Negro Couple during the 1919 Riot</a></p>
<p class="toc-a"><a href="#/html/9780226160702_13_ch2#pla17">17. State Militia on Guard during the 1919 Riots</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226160702_06_pla.vue?9c914696